import { render, staticRenderFns } from "./GraphDetail36.vue?vue&type=template&id=58c530d3&scoped=true&"
import script from "./GraphDetail36.vue?vue&type=script&lang=js&"
export * from "./GraphDetail36.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58c530d3",
  null
  
)

export default component.exports